// extracted by mini-css-extract-plugin
module.exports = {"modal":"IsContinueWarningPopup_modal__2iVVS","header":"IsContinueWarningPopup_header__6HB62","actions":"IsContinueWarningPopup_actions__20_MD"};